module.exports = __webpack_public_path__ + "img/PAI_Landing-Page_Mobile_16.7750e9be.jpg";